module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensedItalic-webfont.ttf?ba6ec64eaceee15f9e8abde5b1c02b4c";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensedItalic-webfont.ttf
// module id = 49
// module chunks = 0